import { buildLoader } from '../util/GenericLoader';
import { fetchDataAlertsAction } from '../../redux/actions/dataAlerts';

export default buildLoader(fetchDataAlertsAction);
